import { z } from 'zod';
/**
 * Models that answer `decide()` questions and nothing else. Kept out of
 * `AI_MODEL_CONFIGS`, so no chat call site, app slot or tier can name one.
 */ export const DecisionModelSchema = z.enum([
    'decision-1'
]);
export const DECISION_MODEL_CONFIGS = {
    'decision-1': {
        deployment: 'Decision-1',
        region: 'germanywestcentral',
        contextWindow: 32_768,
        label: 'Decision-1'
    }
};
export const DEFAULT_DECISION_MODEL = 'decision-1';
export function isDecisionModel(name) {
    return DecisionModelSchema.safeParse(name).success;
}
export function isDecisionModelChoice(choice) {
    return isDecisionModel(choice.model);
}

//# sourceMappingURL=ai-decision-models.js.map